export default __webpack_public_path__ + "static/portrait-0d3d30a64292a56aeba008ba316ee138.png";